// extracted by mini-css-extract-plugin
export var box = "_5s-1";
export var checkboxRow = "_5s-8";
export var checked = "_5s-2";
export var descriptionSpacer = "_5s-a";
export var disabled = "_5s-3";
export var icon = "_5s-6";
export var input = "_5s-0";
export var labelSpacer = "_5s-9";
export var medium = "_5s-5";
export var small = "_5s-4";
export var text = "_5s-7";